import { render, staticRenderFns } from "./channel.schedule.vue?vue&type=template&id=fe2dfbb0&scoped=true"
import script from "./channel.schedule.vue?vue&type=script&setup=true&lang=js"
export * from "./channel.schedule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./channel.schedule.vue?vue&type=style&index=0&id=fe2dfbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2dfbb0",
  null
  
)

export default component.exports